import { render, staticRenderFns } from "./ProductDetailsImages.vue?vue&type=template&id=97e77240"
import script from "./ProductDetailsImages.vue?vue&type=script&lang=ts"
export * from "./ProductDetailsImages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports